import { Box } from "theme-ui";

export default function DownloadIcon(props) {
  return (
    <Box
      as="svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.5 10.5H1.5C0.947715 10.5 0.5 10.0523 0.5 9.5V1.5C0.5 0.947716 0.947715 0.5 1.5 0.5H15.5C16.0523 0.5 16.5 0.947715 16.5 1.5V9.5C16.5 10.0523 16.0523 10.5 15.5 10.5H11.5"
        stroke="black"
        strokeLinecap="round"
      />
      <path d="M8.5 5.5V16.5" stroke="black" strokeLinecap="round" />
      <path
        d="M5.5 13.5L8.5 16.5L11.5 13.5"
        stroke="black"
        strokeLinecap="round"
      />
    </Box>
  );
}
